import { render, staticRenderFns } from "./Beredskap.vue?vue&type=template&id=3de77431&"
import script from "./Beredskap.vue?vue&type=script&lang=js&"
export * from "./Beredskap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports